/* tslint:disable */
/* eslint-disable */

/**
 * 0 = System
 * 
 * 1 = Assistant
 * 
 * 2 = User
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum PortalAiChatRole {
 System = 0,
 Assistant = 1,
 User = 2
}

marker([
    "Enum.PortalAiChatRole.System",
    "Enum.PortalAiChatRole.Assistant",
    "Enum.PortalAiChatRole.User"
]);

export namespace PortalAiChatRole
{
    class DataSets
    {
        static PortalAiChatRoleDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("System", 0, "System"),
            new EnumValue("Assistant", 1, "Assistant"),
            new EnumValue("User", 2, "User"),
        )
    }

    export function getAsDataset() {
        return DataSets.PortalAiChatRoleDataSet;
    }
}
